const defaultState = {
  login: {},
  error: null,
  fetching: false,
  fetched: false,
  authenticated: false
};

const loginReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'LOGIN_FETCH_PENDING': {
      return {
        ...state, fetching: true, authenticated: false
      };
    }
    case 'LOGIN_FETCH_FULFILLED': {
      localStorage.removeItem('signedout');
      localStorage.setItem('login', JSON.stringify(action.payload.login));
      return {
        ...state, fetching: false, fetched: true, authenticated: true, login: action.payload
      };
    }
    case 'LOGIN_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.payload,
        authenticated: false
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default loginReducer;


// WEBPACK FOOTER //
// ./src/reducers/login.js